/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface BulkSetOperationalStatusRequest
 */
export interface BulkSetOperationalStatusRequest {
    /**
     * List of device identities to set operational date on.
     * @type {Array<string>}
     * @memberof BulkSetOperationalStatusRequest
     */
    deviceIdentities?: Array<string>;
    /**
     * Date to mark the device as operational from. Omit to set device as non-operational.
     * @type {Date}
     * @memberof BulkSetOperationalStatusRequest
     */
    operationalAt?: Date;
}

/**
 * Check if a given object implements the BulkSetOperationalStatusRequest interface.
 */
export function instanceOfBulkSetOperationalStatusRequest(
    value: object,
): value is BulkSetOperationalStatusRequest {
    return true;
}

export function BulkSetOperationalStatusRequestFromJSON(
    json: any,
): BulkSetOperationalStatusRequest {
    return BulkSetOperationalStatusRequestFromJSONTyped(json, false);
}

export function BulkSetOperationalStatusRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): BulkSetOperationalStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        deviceIdentities:
            json["deviceIdentities"] == null
                ? undefined
                : json["deviceIdentities"],
        operationalAt:
            json["operationalAt"] == null
                ? undefined
                : new Date(json["operationalAt"]),
    };
}

export function BulkSetOperationalStatusRequestToJSON(
    value?: BulkSetOperationalStatusRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceIdentities: value["deviceIdentities"],
        operationalAt:
            value["operationalAt"] == null
                ? undefined
                : value["operationalAt"].toISOString(),
    };
}
